import favicon from "../images/dealiem_favicon.ico";
import Helmet from "react-helmet";
import * as React from "react";

const queryString = require("query-string");

function getMarketInfo(market) {
    const marketMap = {
        gta: {
            location: "Toronto",
            fullLocation: "Toronto, Ontario",
            keywords: "toronto, ontario, gta",
        },
        austin: {
            location: "Austin",
            fullLocation: "Austin, Texas",
            keywords: "austin, texas",
        },
        nyc: {
            location: "New York",
            fullLocation: "New York City",
            keywords: "new york, nyc, manhattan",
        },
        chicago: {
            location: "Chicago",
            fullLocation: "Chicago, Illinois",
            keywords: "chicago, illinois",
        },
        miami: {
            location: "Miami",
            fullLocation: "Miami, Florida",
            keywords: "miami, florida",
        },
        seattle: {
            location: "Seattle",
            fullLocation: "Seattle, Washington",
            keywords: "seattle, washington",
        },
        sfbay: {
            location: "San Francisco Bay Area",
            fullLocation: "San Francisco Bay Area, California",
            keywords: "san francisco, bay area, sfbay, california",
        },
        losangeles: {
            location: "Los Angeles",
            fullLocation: "Los Angeles, California",
            keywords: "los angeles, la, california",
        },
        portland: {
            location: "Portland",
            fullLocation: "Portland, Oregon",
            keywords: "portland, oregon",
        },
        lasvegas: {
            location: "Las Vegas",
            fullLocation: "Las Vegas, Nevada",
            keywords: "las vegas, nevada",
        },
    };
    return marketMap[market] || marketMap.gta;
}

export function getSeoMainPage(market = "gta") {
    const marketInfo = getMarketInfo(market);
    const seoFields = {
        title: `Best happy hour and deals finder in ${marketInfo.location} - Dealiem`,
        description: `Find your next happy hour, drink and food special, or daily deals in ${marketInfo.fullLocation}, all in one place`,
        keywords: `dealiem, deal, deals, offer, happy, discount, food, cheap, hour, ${marketInfo.keywords}, restaurants, near, specials, wings, oyster, beer`,
    };

    const query = queryString.parse(document.location.search)["q"];
    if (query && query !== "") {
        seoFields.title =
            capitalizeFirstLetter(query) +
            ` deals in ${marketInfo.location} for any day of the week - Dealiem`;
        seoFields.description =
            `Find your next ` +
            query.toLowerCase() +
            `, happy hour, drink and food special, or daily deals in ${marketInfo.fullLocation}, all in one place`;
        seoFields.keywords += ", " + query.toLowerCase();
    }

    const ogImage =
        typeof window !== "undefined"
            ? `${window.location.origin}/dealiem-og-image.jpeg`
            : "/dealiem-og-image.jpeg";
    const ogUrl = typeof window !== "undefined" ? window.location.href : "";

    return (
        <Helmet
            key={`seo-main-${market}`}
            onChangeClientState={(newState, addedTags, removedTags) => {
                document
                    .querySelectorAll("meta[original-meta-tag='true']")
                    .forEach(function (child) {
                        child.parentNode.removeChild(child);
                    });
            }}
        >
            <meta charSet="utf-8" />
            <title>{seoFields.title}</title>
            <link rel="icon" href={favicon} />
            <meta
                name="viewport"
                content="width=device-width, initial-scale=1, maximum-scale=1"
            />
            <meta name="theme-color" content="#f9f9f9" />
            <meta name="description" content={seoFields.description} />
            <meta name="keywords" content={seoFields.keywords} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content="website" />
            <meta property="og:url" content={ogUrl} />
            <meta property="og:title" content={seoFields.title} />
            <meta property="og:description" content={seoFields.description} />
            <meta property="og:image" content={ogImage} />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:url" content={ogUrl} />
            <meta name="twitter:title" content={seoFields.title} />
            <meta name="twitter:description" content={seoFields.description} />
            <meta name="twitter:image" content={ogImage} />
        </Helmet>
    );
}

export function getSeoDetailPage(business, market = "gta") {
    const marketInfo = getMarketInfo(market);
    const seoFields = {
        title: `Best happy hour and deals finder in ${marketInfo.location} - Dealiem`,
        description: `Find your next happy hour, drink and food special, or daily deals in ${marketInfo.fullLocation}, all in one place`,
        keywords: `dealiem, deal, deals, offer, happy, discount, food, cheap, hour, ${marketInfo.keywords}, restaurants, near, specials, wings, oyster, beer`,
    };

    if (business.SeoTitle) {
        seoFields.title = business.SeoTitle;
    } else if (business.Name) {
        seoFields.title = business.Name + ": Best deals on Dealiem";
    }
    if (business.SeoDescription) {
        seoFields.description = business.SeoDescription;
    }
    if (business.SeoKeywords) {
        seoFields.keywords = business.SeoKeywords;
    }

    const ogImage =
        business.Photos && business.Photos.length > 0
            ? business.Photos[0].Url
            : typeof window !== "undefined"
            ? `${window.location.origin}/dealiem-og-image.jpeg`
            : "/dealiem-og-image.jpeg";
    const ogUrl = typeof window !== "undefined" ? window.location.href : "";

    return (
        <Helmet
            onChangeClientState={(newState, addedTags, removedTags) => {
                document
                    .querySelectorAll("meta[original-meta-tag='true']")
                    .forEach(function (child) {
                        child.parentNode.removeChild(child);
                    });
            }}
        >
            <title>{seoFields.title}</title>
            <meta name="description" content={seoFields.description} />
            <meta name="keywords" content={seoFields.keywords} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content="website" />
            <meta property="og:url" content={ogUrl} />
            <meta property="og:title" content={seoFields.title} />
            <meta property="og:description" content={seoFields.description} />
            <meta property="og:image" content={ogImage} />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:url" content={ogUrl} />
            <meta name="twitter:title" content={seoFields.title} />
            <meta name="twitter:description" content={seoFields.description} />
            <meta name="twitter:image" content={ogImage} />
        </Helmet>
    );
}

function capitalizeFirstLetter(s) {
    s = s.toLowerCase();
    return s.charAt(0).toUpperCase() + s.slice(1);
}
